<template>
    <div class="contacts">
        <div class="contacts-left">
            <GmapMap ref="gmap"
                class="contacts-map"
                :center="mapCenter"
                :zoom="17"
                :options="{
                    disableDefaultUI : true,
                    styles: mapStyle
                }"
                map-type-id="terrain"
                >
                <GmapMarker
                    :position="{
                      lat: 42.6636479,
                      lng: 23.2574857
                    }"
                    :clickable="true"
                    :icon="{
                      url: '/static/img/location.svg',
                      size: {width: 74, height: 87, f: 'px', b: 'px'},
                      scaledSize: {width: 74, height: 87, f: 'px', b: 'px'}
                    }"
                >
                </GmapMarker>
            </GmapMap>
        </div>
        <div class="contacts-right" id="contactsRight">
            <div class="contacts-top">
                <h4>Свържете се с нас</h4>
                <span>Попълнете вашите детайли</span>
            </div>
            <div class="contacts-right-form" v-if="!isSent">
                <div class="contacts-right-form-input">
                    <label for="contactsName" v-if="isNameValid">Вашето име</label>
                    <label for="contactsName" v-else :class="{ 'not-valid' : !isNameValid }">Вашето име е задължително</label>
                    <input type="text" id="contactsName" :class="{ 'not-valid-border' : !isNameValid }" v-model="request.name">
                </div>
                <div class="contacts-right-form-input">
                    <label for="contactsEmail" v-if="isEmailValid">e-mail</label>
                    <label for="contactsEmail" v-else :class="{ 'not-valid' : !isEmailValid }">e-mail-a е задължителен</label>
                    <input type="text" id="contactsEmail" :class="{ 'not-valid-border' : !isEmailValid }" v-model="request.email">
                </div>
                <div class="contacts-right-form-input">
                    <label for="contactsPhone" v-if="isPhoneValid">Телефон</label>
                    <label for="contactsPhone" v-else :class="{ 'not-valid' : !isPhoneValid }">Телефона е задължителен</label>
                    <input type="text" id="contactsPhone" :class="{ 'not-valid-border' : !isPhoneValid }" v-model="request.phone">
                </div>
                <div class="contacts-right-form-input contacts-right-form-textarea">
                    <label for="contactsMessage"  v-if="isMessageValid && isMessageLengthValid">Съобщение</label>
                    <label for="contactsMessage" v-else-if="!isMessageLengthValid && isMessageValid" :class="{ 'not-valid' : !isMessageLengthValid }">Допустимата дължина е 1600</label>
                    <label for="contactsMessage" v-else :class="{ 'not-valid' : !isMessageValid }">Съобщението е задължително</label>
                    <textarea id="contactsMessage" cols="30" rows="10" :class="{ 'not-valid-border' : !isMessageValid }" v-model="request.message"></textarea>
                </div>
    
        <div class="btn-wrapper">
          <!-- <div class="captcha-wrapper" v-if="captcha">
            <p class="captcha--p" v-if="captcha.numOne && captcha.numTwo">
              {{ captcha.numOne }} + {{ captcha.numTwo }} =
            </p>
            <input
              class="captchaSum"
              :class="{ 'not-valid-border': !isCaptchaValid }"
              type="number"
              :min="0"
              oninput="validity.valid || (value='')"
              :step="0.01"
              v-model="request.captchaSum"
            />
          </div> -->
          <!-- <a class="contacts-right-form-submit" @click="sendInquiry('',false, captcha)"> -->
          <a class="contacts-right-form-submit" @click="sendInquiry('', false)">
            <template v-if="isSent">Готово</template>
            <template v-else-if="isLoading && !isSent">Един момент</template>
            <template v-else>Изпрати</template>
          </a>
        </div>
            </div>
            <div class="contacts-success" v-if="isSent">
              <p>Запитването е изпратено успешно!</p>
              <p>Ще се свържем с вас до 48 часа.</p>
            </div>
            <p class="agreement">С изпращането на това запитване вие се съгласявате с <router-link class="link" to="/gdpr" target="_blank">Нашата политика за поверителност на потребителските данни</router-link>.</p>
        </div>
    </div>
</template>

<script>
import googlePopup from "./mixins/googleMapPopupMixin.js";
import googleMapStyles from "../assets/google-map-styles.json";
import sendInquiry from "./mixins/sendInquiry.js";
// import captcha from './mixins/captcha.js';
export default {
  mixins: [googlePopup, sendInquiry],
  data() {
    return {
      mapStyle: googleMapStyles,
      mobile: false,
      // captcha: ""
    };
  },
  //     watch: {
  //   isLoading() {
  //     if (this.isLoading) {
  //       this.captcha = this.getCaptcha();
  //     }
  //   },
  // },
    computed: {
    mapCenter() {
      return {
        lat: 42.6636479,
        lng: this.mobile ? 23.2585 : 23.2574857,
      };
    },
  },
  methods: {
    onResize() {
      this.mobile = window.innerWidth <= 600;
    },
    scrollToInquiry(event) {
      if (event.target.id == "contactsInquiryBtn") {
        const inquiryWrapperEl = document.getElementById("contactsRight");
        if (inquiryWrapperEl) {
          window.scrollTo({
            top: inquiryWrapperEl.offsetTop,
            behavior: "smooth"
          });
        }
      }
    }
  },
  mounted() {
    // this.captcha = this.getCaptcha();
    document.addEventListener("mouseup", this.scrollToInquiry);
    window.addEventListener("resize", this.onResize);
    this.onResize()
  },
  destroyed() {
    document.removeEventListener("mouseup", this.scrollToInquiry);
    window.removeEventListener("resize", this.onResize);
  },
};
</script>

<style scoped>
.contacts {
  display: flex;
  margin-top: -145px;
  height: 100vh;
}
/* BOTH LEFT AND RIGHT SIDE */
.contacts-top {
  align-items: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
}
.contacts-top > h4 {
  color: #fff;
}
.contacts-top > span {
  color: #fff;
  font-size: 14px;
}
/* LEFT */
.contacts-left {
  align-items: center;
  background: rgb(255, 255, 255);
  background: -moz-linear-gradient(
    top,
    rgba(255, 255, 255, 1) 0%,
    rgba(245, 245, 245, 1) 100%
  );
  background: -webkit-linear-gradient(
    top,
    rgba(255, 255, 255, 1) 0%,
    rgba(245, 245, 245, 1) 100%
  );
  background: linear-gradient(
    to bottom,
    rgba(255, 255, 255, 1) 0%,
    rgba(245, 245, 245, 1) 100%
  );
  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#ffffff', endColorstr='#f5f5f5',GradientType=0 );
  display: flex;
  flex-direction: column;
  height: 100%;
  justify-content: space-between;
  padding: 0;
  position: relative;
  width: 50%;
}
.contacts-map {
  width: 100%;
  height: 100%;
}
/* RIGHT */
.contacts-right {
  align-items: center;
  background-color: #313131;
  display: flex;
  flex-direction: column;
  height: 100%;
  justify-content: space-between;
  padding: 160px 0 25px;
  width: 50%;
}
.contacts-success p {
  color: #c4c4c4;
  font-size: 24px;
  text-align: center;
}
.contacts-right-form-input {
  height: 60px;
  margin: 26px 0;
  position: relative;
  width: 410px;
}
.contacts-right-form-textarea {
  height: 110px;
}
.contacts-right-form-input > input,
.contacts-right-form-input > textarea {
  background-color: #313131;
  border: 1px solid #a7a7a7;
  border-radius: 8px;
  color: #fff;
  font-size: 16px;
  outline: none;
  padding: 0 25px;
  width: 100%;
  height: 60px;
}
.contacts-right-form-input > textarea {
  height: 110px;
  padding: 25px;
  resize: none;
}
.contacts-right-form-input > label {
  background-color: #313131;
  color: #fff;
  font-size: 16px;
  left: 15px;
  padding: 0 10px;
  position: absolute;
  top: -9px;
}
.btn-wrapper {
  display: flex;
  gap: 15px;
  padding-top: 10px;
  justify-content: center;
  text-align: center;
  width: 100%;
}
.captcha-wrapper {
  align-items: center;
  display: flex;
}
  .captcha--p {
     color: #fff;
    font-size: 14px;
    white-space: nowrap;
  }
  .captchaSum {
  background-color: #313131;
  border: 1px solid #a7a7a7;
  border-radius: 8px;
  color: #fff;
  font-size: 14px;
  outline: none;
  margin-left: 5px;
  max-width: 50px;
  padding: 5px;
  }
.contacts-right-form-submit {
  align-items: center;
  background-color: #ffffff;
  color: #000;
  cursor: pointer;
  display: inline-flex;
  font-size: 18px;
  font-weight: 700;
  height: 45px;
  justify-content: center;
  width: 178px;
}
.contacts-right-form-submit:hover {
  background-color: #ebebeb;
}
.agreement {
  color: rgba(138, 138, 138, 0.8);
  font-size: 12px;
  text-align: center;
  margin: 15px 0;
  width: 410px;
}
.link {
  color: rgba(138, 138, 138, 0.8);
  text-decoration: underline;
}

@media screen and (max-width: 1600px) {
  .contacts-right-form-input {
    height: 50px;
    margin: 20px 0;
    width: 350px;
  }
  .contacts-right-form-input > input {
    height: 50px;
  }
  .contacts-right-form-textarea {
    height: 100px;
  }
  .contacts-right-form-input > textarea {
    height: 100px;
  }
  .btn-wrapper {
    align-items: center;
    flex-direction: column;
    padding-top: 0;
  }
  .contacts-success p {
    font-size: 20px;
  }
}
@media screen and (max-width: 1440px) {
  .contacts {
    margin-top: -100px;
  }
  .contacts-right {
    padding-top: 100px;
  }
  .contacts-right-form-submit {
    font-size: 14px;
  }
  .contacts-right-form-input > label {
    font-size: 14px;
    top: -8px;
  }
}
@media screen and (max-width: 1366px) {
  .contacts-top > span {
    font-size: 12px;
  }
  .contacts-showcase-item::before {
    height: 20px;
    width: 20px;
  }
  .contacts-showcase-item::after {
    left: 40px;
  }
  .contacts-showcase-item-p {
    font-size: 12px;
  }
  .contacts-right-form-input {
    height: 40px;
    margin: 15px 0;
    width: 300px;
  }
  .contacts-right-form-input > label {
    font-size: 12px;
  }
  .contacts-right-form-input > input {
    font-size: 14px;
    height: 40px;
  }
  .contacts-right-form-textarea,
  .contacts-right-form-input > textarea {
    font-size: 14px;
    height: 80px;
  }
  .contacts-right-form-submit {
    height: 40px;
    width: 150px;
  }
  .agreement {
    font-size: 12px;
  }
}
@media screen and (max-width: 1280px) {
  .contacts {
    flex-direction: column;
    height: initial;
  }
  .contacts-left,
  .contacts-right {
    width: 100%;
    min-height: 100vh;
  }
  .contacts-right {
    min-height: initial;
  }
  .contacts-left {
    height: 100vh;
  }
  .contacts-right {
    padding: 50px 20px 63px;
  }
}
@media screen and (max-width: 600px) {
  .contacts-right {
    padding-bottom: 50px;
  }
  .contacts-right-form,
  .agreement {
    width: 280px;
  }
  .contacts-right-form-input {
    width: 100%;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Contacts.vue